import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import InputCell from './InputCell';

import t from '../../utils/lang'

const styles = theme => ({
  root: {
    '& tr td:first-child, & tr th:first-child': {
      width: 'auto',
      minWidth: 100,
      padding: 0
    },
    '& tr td:not(:first-child), & tr th:not(:first-child)': {
      '@media screen and (max-width: 500px)': {
        padding: `0 0 0 ${theme.spacing.unit * 2}px !important`,
      },
      '@media screen and (min-width: 501px) and (max-width: 768px)': {
        padding: `0 0 0 ${theme.spacing.unit * 4}px !important`,
      },
      '@media screen and (min-width: 769px) and (max-width: 1280px)': {
        padding: `0 0 0 ${theme.spacing.unit * 8}px !important`,
      },
      '@media screen and (min-width: 1281px)': {
        padding: `0 0 0 ${theme.spacing.unit * 16}px !important`,
      },
      width: '100px',
    },
  },
  tableContainer: {
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    overflowX: 'auto'
  },
  storageAddOn: {
    textAlign: 'right'
  }
});

class SpaceTable extends Component {
  constructor(props) {
    super(props)
  }

  handleChange = (field, value) => {
    const { handleUpdate } = this.props;
    handleUpdate(field, value);
  }

  render() {
    const { classes, i18n, space, proposalSubmitted, storageAddOn, handleChangeStorageAddOn } = this.props;

    const spaceTypes = [
      { key: 'office', name: i18n.office },
      { key: 'retail', name: i18n.retail },
      { key: 'storage', name: i18n.storage }
    ]

    const rows = [
      { key: 'net', field: 'net_space', name: i18n.netSpace },
      { key: 'gross', field: 'gross_space', name: i18n.grossSpace }
    ];

    return (
      <div className={classes.tableContainer}>
        <MuiTable className={classes.root}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              {spaceTypes.map(({ key, name }) =>
                <TableCell align="center" key={key}>
                  <b>{name}</b>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, key) => (
              <TableRow key={key}>
                <TableCell scope="row">
                  <b>{row.name}</b>
                </TableCell>
                {spaceTypes.map((type, key) => {
                  const rowKey = storageAddOn && type.key === 'storage' ? 'net' : row.key;
                  return <InputCell
                    key={`${row.key}_${type.key}`}
                    value={space ? space[`${rowKey}_${type.key}`] : ''}
                    disabled={proposalSubmitted}
                    onChange={e => this.handleChange(`${rowKey}_${type.key}`, e.target.value)}
                    inputAdornment='m²'
                  />
                })}
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
        <div className={classes.storageAddOn}>
          <FormControlLabel
            control={
              <Checkbox
                checked={storageAddOn}
                disabled={proposalSubmitted}
                onChange={handleChangeStorageAddOn}
              />
            }
            label={i18n.storageAddOn}
            labelPlacement="start"
          />
        </div>
      </div>
    )
  }
}

SpaceTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps({ rfpData }) {
  const { id, lang, statusId } = rfpData

  return {
    rfpId: id,
    i18n: t[lang],
    proposalSubmitted: statusId === 3
  }
}

export default connect(mapStateToProps)(withStyles(styles)(SpaceTable))


// WEBPACK FOOTER //
// ./src/components/CommercialTerms/SpaceTable.js